export const SET_HOMOLOGATION_STATUS = 'SET_HOMOLOGATION_STATUS';
export const SET_HOMOLOGATION_DOWNLOADED = 'SET_HOMOLOGATION_DOWNLOADED';
